import { useMemo } from 'react';
import { useWindowScroll } from 'react-use';

export function usePageScrolled() {
  const { y } = useWindowScroll();
  const isScrolled = useMemo(() => y > 0, [y]);
  return isScrolled;
}
